var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'card-container',
    _vm.mode === 'HORIZONTAL'
      ? 'card-container_horizontal'
      : 'card-container_vertical'
  ]},[_vm._t("image",function(){return [_c('div',{staticClass:"image"},[_c('img',{staticClass:"img_ad",attrs:{"src":_vm.adCardInfo._imgSrc}})])]}),_vm._t("desc",function(){return [_c('div',{staticClass:"desc"},[_c('div',{staticClass:"sub-title r-ellipsis-l2"},[_vm._v(_vm._s(_vm.adCardInfo._subTitle))]),_c('div',{staticClass:"intro"},[(_vm.adCardInfo._date)?[_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.adCardInfo._date))])]:_vm._e(),(_vm.adCardInfo._clickNum)?[_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.adCardInfo._clickNum)+"观看")])]:_vm._e()],2)])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }